require('./club-scorecard-detail.jade')
_ = require("lodash")

ClubScoreCardDetailDirective = ($filter)->
  templateUrl: "club/club-scorecard/club-scorecard-detail.jade"
  scope:
    course: '=course'
    name: '=courseName'
    show: '=show'
  link: (scope) ->
    scope.holes9 = [1, 2, 3, 4, 5, 6, 7, 8, 9]
    scope.holes18 = [10, 11, 12, 13, 14, 15, 16, 17, 18]

    scope.getDistance = (holes, hole_num) ->
      hole = _.find holes, _.matches {num: hole_num}
      return if hole then hole.distance else ""

    scope.getPar = (holes, hole_num) ->
      hole = _.find holes, _.matches {num: hole_num}
      return if hole then hole.men_par else "-"

ClubScoreCardDetailDirective.$inject = [
  "$filter"
]

module.exports = ClubScoreCardDetailDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/club-scorecard/club-scorecard-detail-directive.coffee